<template>
  <article :class="{ entry: true, 'entry-publication': true, 'entry-publication-dedans_dehors': isDedansDehors, 'entry-publication-autre': isOuvrage }">
    <div class="row">
      <div class="col-xs-12 col-sm-3 entry-thumbnail-container">
        <img class="entry-thumbnail" :src="thumbnailUrl" alt="Dedans Dehors">
      </div>
      <div class="col-xs-12 col-sm-9 entry-content-container">
        <header class="entry-header">
          <h3 class="entry-title" v-html="title"></h3>
        </header>
        <div class="entry-content">
          <div class="entry-resume" v-html="publication.resume">
          </div>
          <div class="two-blocks-red-link-container">
            <a class="two-blocks-red-link" :href="publication.link">Découvrir</a>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
  export default {

    props: {
      publication: Object
    },

    computed: {

      title () {
        if (this.publication.type_de_la_publication == 'dedans_dehors') {
          return 'Dedans Dehors n°' + this.publication.numero + ' - ' + this.publication.date_de_parution + '<br>' + this.publication.title.rendered
        }

        return this.publication.title.rendered
      },

      thumbnailUrl () {
        if (this.publication.hasOwnProperty('_embedded')) {
          if (this.publication._embedded.hasOwnProperty('wp:featuredmedia')) {
            if (0 in this.publication._embedded['wp:featuredmedia']) {
              if ('media_details' in this.publication._embedded['wp:featuredmedia'][0]) {
                if ('sizes' in this.publication._embedded['wp:featuredmedia'][0].media_details) {
                  if ('publication-entry' in this.publication._embedded['wp:featuredmedia'][0].media_details.sizes) {
                    if ('source_url' in this.publication._embedded['wp:featuredmedia'][0].media_details.sizes['publication-entry']) {
                      return this.publication._embedded['wp:featuredmedia'][0].media_details.sizes['publication-entry'].source_url
                    }
                  }

                  return this.publication._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url
                }
              }
            }
          }
        }

        return null
      },

      isDedansDehors () {
        return this.publication.type_de_la_publication === 'dedans_dehors'
      },

      isOuvrage () {
        return this.publication.type_de_la_publication === 'autre'
      }

    },

    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/publications/PublicationEntry.vue